import * as THREE from "three";

import Debug from "./Utils/Debug.js";
import Sizes from "./Utils/Sizes.js";
import Time from "./Utils/Time.js";
import Camera from "./Camera.js";
import Renderer from "./Renderer.js";
import World from "./World/World.js";
import Resources from "./Utils/Resources.js";
import Noises from "./Utils/noise/Noises.js";

import sources from "./sources.js";

let instance = null;

export default class Experience {
    constructor(_canvas) {
        // Singleton
        if (instance) {
            return instance;
        }
        instance = this;

        // Global access
        window.experience = this;

        // Options
        this.canvas = _canvas;

        // Setup
        this.debug = new Debug();
        this.sizes = new Sizes();
        this.time = new Time();
        this.scene = new THREE.Scene();
        this.resources = new Resources(sources);
        this.camera = new Camera();
        this.renderer = new Renderer();
        this.noiseMaker = new Noises();
        this.readyNoiseTextures();
        this.world = new World();

        // Resize event
        this.sizes.on("resize", () => {
            this.resize();
        });

        // Time tick event
        this.time.on("tick", () => {
            this.update();
        });
    }

    // Setup reusable noise textures for caustics and other effects
    readyNoiseTextures() {
        const noiseWidth = 1024;
        const noiseHeight = 1024;
        const noiseRT = this.noiseMaker.create(noiseWidth, noiseHeight);
        this.noiseTextureRT = noiseRT;
        this.noiseTexture = noiseRT.texture;
        const noise2RT = this.noiseMaker.createWorley(noiseWidth, noiseHeight);
        this.worleyTextureRT = noise2RT;
        this.worleyTexture = noise2RT.texture;
    }

    resize() {
        this.camera.resize();
        this.renderer.resize();
    }

    update() {
        if (this.debug.active) {
            this.debug.update();
        }
        this.camera.update();
        this.world.update();
        this.renderer.update();
    }

    destroy() {
        this.sizes.off("resize");
        this.time.off("tick");

        // Traverse the whole scene
        this.scene.traverse((child) => {
            // Test if it's a mesh
            if (child instanceof THREE.Mesh) {
                child.geometry.dispose();

                // Loop through the material properties
                for (const key in child.material) {
                    const value = child.material[key];

                    // Test if there is a dispose function
                    if (value && typeof value.dispose === "function") {
                        value.dispose();
                    }
                }
            }
        });

        this.camera.controls.dispose();
        this.renderer.instance.dispose();

        if (this.debug.active) this.debug.destroy();
    }
}
